import { Routes } from '@angular/router';
import { PrepareComponent } from './prepare.component';

export const PREPARE_ROUTES: Routes = [
    {
        path: '',
        component: PrepareComponent,
    }
];
